<footer class="footer">
  <div class="container-fluid">
    <nav class="pull-left">
      <ul></ul>
    </nav>
    <div class="copyright pull-right">
      &copy; {{ test | date: 'yyyy' }}, BearStarsStudio
    </div>
  </div>
</footer>
